import { CallSplit } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { get } from 'lodash';
import React from 'react';
import { createStockSplit } from '../../../http/CompaniesApi';

export default function AddStockSplitDialog({
  companyId,
  companyName,
  addStockSplitDialogOpen,
  setAddStockSplitDialogOpen,
  setErrMessage,
  errMessage,
  setSnackOpen,
  onSuccess,
}) {
  const initialFormData = Object.freeze({
    splitFactor: '',
    splitDate: new Date(),
  });
  const [formData, setFormData] = React.useState(initialFormData);

  const handleDateChange = (newValue) => {
    setFormData({
      ...formData,
      splitDate: newValue,
    });
  };

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const { splitFactor, splitDate } = formData;
      await createStockSplit(companyId, {
        splitFactor: parseFloat(splitFactor),
        splitDate: splitDate.toISOString(),
      });
      setAddStockSplitDialogOpen(false);
      setFormData(initialFormData);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setErrMessage(get(err, 'response.data.message', errMessage));
      setSnackOpen(true);
    }
  };

  return (
    <Dialog
      open={addStockSplitDialogOpen}
      onClose={() => setAddStockSplitDialogOpen(false)}
    >
      <DialogTitle>Add Stock Split for {companyName}</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <TextField
            type="number"
            name="splitFactor"
            style={{ margin: 10 }}
            label="Split Factor"
            placeholder="e.g., 2 for 2:1 split"
            inputProps={{ step: 'any', min: 0.01 }}
            value={formData.splitFactor}
            onChange={handleChange}
            required
            fullWidth
          />
          <Box style={{ margin: 10 }}>
            <MobileDatePicker
              name="splitDate"
              label="Split Date"
              inputFormat="dd/MM/yyyy"
              value={formData.splitDate}
              onChange={handleDateChange}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </Box>
          <Box style={{ margin: 10, marginTop: 20 }}>
            <Button variant="contained" endIcon={<CallSplit />} type="submit">
              Add Stock Split
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
}
